export const messageReactNative = (type, body) => {
  if (window.ReactNativeWebView) {
    // send data object to React Native
    window.ReactNativeWebView.postMessage(JSON.stringify({ type, body }));
  }
};
